var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.displayPaymentSection()
    ? _c("section", [
        _c("div", { staticClass: "card panel-white" }, [
          _c("div", { staticClass: "card-body" }, [
            _c("h3", [_vm._v(_vm._s(_vm.title))]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.message))]),
            _vm._v(" "),
            _c("div", { staticClass: "row no-gutters" }, [
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _vm.$route.matched[0].path === "/chat-booking"
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-info btn-block",
                          on: {
                            click: function($event) {
                              return _vm.openPaymentDialog()
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t(
                                  "message.service_request.service_request_button_payment"
                                )
                              ) +
                              "\n          "
                          )
                        ]
                      )
                    : _c(
                        "router-link",
                        {
                          staticClass: "btn btn-info btn-block",
                          attrs: {
                            to:
                              "/service-requests/" +
                              _vm.serviceRequest.id +
                              "/payment"
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t(
                                  "message.service_request.service_request_button_payment"
                                )
                              ) +
                              "\n          "
                          )
                        ]
                      )
                ],
                1
              )
            ])
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-57e3c4f3", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57e3c4f3","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/serviceRequest/Components/PaymentSection.vue
// module id = 2171
// module chunks = 0